<template>
  <v-dialog v-model="visible" width="25rem" persistent scrollable>
    <v-card>
      <v-toolbar color="primary white--text" flat>
        <sabira_icon
          icon="security"
          class="mr-2"
          :strokewidth="3"
          fill="white"
        />
        <v-toolbar-title class="ml-1 text-wrap" style="line-height:1.3">
          Reset lozinke
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-3 pt-2 pl-3 pr-3">
        <div class="mb-4 pl-3 text-subtitle-1">
          Unesite novu korisničku lozinku.
        </div>
        <form>
          <v-text-field
            v-model="password"
            :label="$t('password')"
            placeholder=" "
            clear-icon="mdi-close"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            class="mt-4 mb-2"
            persistent-hint
            hide-details
            outlined
            prepend-inner-icon="mdi-lock-outline"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @keyup.enter="save_new_password()"
            autocomplete="new-password"
          ></v-text-field>
        </form>
      </v-card-text>
      <v-card-actions class="background">
        <v-btn text @click="close_dialog()">Odustani</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="save_new_password()">Pošalji</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: null,
    },
  },
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
  },
  data: () => ({
    showPassword: false,
    password: null,
    visible: false,
  }),
  methods: {
    close_dialog() {
      this.$webpageEventBus.$emit("close_new_pass_dialog");
    },
    save_new_password() {
      this.$http({
        method: "post",
        url: "/user/reset/new_password",
        data: {
          password: this.password,
          email: this.email,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("close_new_pass_dialog");
          this.$webpageEventBus.$emit("show_status", {
            message: "Lozinka je uspješno promijenjena",
            type: "success",
            timeout: 5000,
          });
          this.$router.push("/login");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            message: "Došlo je do greške prilikom reseta lozinke",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.visible = true;
  },
};
</script>
